export const formatNumber = (amount: number) => {
  return amount.toLocaleString('en-US', {
    style: 'decimal',
    maximumFractionDigits: 2,
  })
}

export const formatPercentage = (value: number) => {
  return value.toLocaleString('en-US', {
    style: 'percent',
    maximumFractionDigits: 2,
  })
}

export const sum = <T extends object>(
  values: T[],
  fn: (value: T) => number,
) => {
  return Number.parseFloat(
    values.reduce((acc, value) => acc + fn(value), 0).toFixed(2),
  )
}

export const formatBallots = (value: string) => {
  const ballots = value.match(/.{1,2}/g)
  return ballots?.map(ballot => ballot.padStart(2, '0')) ?? []
}
